import { createContext } from "react";

export const InvestTransactionContext = createContext();

